import React from 'react'
import { observer } from 'mobx-react'
import mainStore from '@components/Main/store'
import { Auth } from '@common/Auth'
import { Head } from '@merchant-backend/common-components'
import {
  avatar,
  HLJ_MERCHANT_MY_COUNT
} from '@merchant-backend/common-components/src/Head/constant'
import styles from './style.module.less'
import { DownOutlined } from '@ant-design/icons'
import { Dropdown, Menu, Select, Tooltip } from 'hljd'
import { Link } from 'react-router'
import {
  PRIVILEGE_GROUP_ID,
  PRIVILEGE_NORMAL_ID,
  PRIVILEGE_NORMAL_SERVICE_ID,
  TOP_BANNER_HEIGHT,
  TOP_HEADER_HEIGHT,
  PANGU_HOME
} from '@constant'
import {
  getJti,
  getMerchantInfo,
  isImageMogr2,
  isSanDaTeam,
  isSiDaMember,
  isSiDaTeam,
  logoutAction
} from '@util'
import LoginSub from '@components/LocalMerchant/SiDa/Common/LoginSub'
import API from '@api/bi_nuo'
import PanguApi from '@api/pangu'
import exclusiveCodeStore from '../Home/ExclusiveCode/store'
import Tracker from '@components/Tracker'

const SubMenu = Menu.SubMenu

@Auth({
  role: [PRIVILEGE_NORMAL_ID, PRIVILEGE_NORMAL_SERVICE_ID, PRIVILEGE_GROUP_ID]
})
@observer
export default class Header extends React.Component {
  state = {
    merchantList: []
  }

  getMerchantList = async () => {
    const { success, data } = await API.merchantList({
      merchant_id: getMerchantInfo().id
    })
    if (success) {
      const merchantList = data.map(item => {
        const prefix = item.shopType == 5 ? '【团队】' : '【个人】'
        item.value = item.id && item.id.toString()
        item.label = prefix + item.name
        return item
      })
      this.setState({ merchantList })
    }
  }

  recordStoreJumpMode = async () => {
    const { success } = await PanguApi.recordStoreJumpMode({
      storeSeqId: getMerchantInfo().store_seq_id
    })
    if (success) {
      window.location.replace(PANGU_HOME + getJti())
    }
  }

  componentDidMount() {
    this.getMerchantList()
  }

  // 自定义menu
  RenderMenu = (style, store) => {
    const { smallWindow } = store
    const { visible } = exclusiveCodeStore

    return (
      <Menu mode="horizontal">
        <SubMenu
          title={
            <Tooltip
              placement="bottom"
              title={smallWindow ? '婚礼纪商家App' : ''}
              overlayClassName={style.head_tooltip}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: TOP_HEADER_HEIGHT
                }}
              >
                <img
                  src="//qnm.hunliji.com/o_1dseje7f6j3b1f7t7nl8395amf.png"
                  alt="婚礼纪商家App"
                  className={style['header-menu-icon']}
                />
                <span className={style['menu-name']}>婚礼纪商家App</span>
              </span>
            </Tooltip>
          }
        >
          {!smallWindow && (
            <Menu.Item
              key="app"
              style={{
                height: 'auto',
                backgroundColor: 'initial',
                textAlign: 'center'
              }}
            >
              <img
                src="//qnm.hunliji.com/o_1b39vqmlr1a79dha10aebgatu57.jpg"
                alt="下载婚礼纪商家版App"
              />
              <p style={{ fontSize: 12, textAlign: 'center' }}>
                下载婚礼纪商家版App
              </p>
            </Menu.Item>
          )}
        </SubMenu>
        <Menu.Item key="hlj">
          <Tooltip
            placement="bottom"
            title={smallWindow ? '官网首页' : ''}
            overlayClassName={style.head_tooltip}
          >
            <Link
              href="/p/frontend/merchant-center/dist/index.html#/home"
              target="_blank"
              style={{
                display: 'flex',
                alignItems: 'center',
                height: TOP_HEADER_HEIGHT
              }}
            >
              <Tracker
                mode={['view']}
                data={Tracker.trackBuild('首页-顶部banner-曝光')}
              >
                <img
                  src="//qnm.hunliji.com/o_1dseje7f51tel1db41198r0ifesc.png"
                  alt="官网首页"
                  className={style['header-menu-icon']}
                />
              </Tracker>
              <span className={style['menu-name']}>官网首页</span>
            </Link>
          </Tooltip>
        </Menu.Item>
        <Menu.Item key="contact">
          <Tooltip
            placement="bottom"
            title={smallWindow ? '联系我们' : ''}
            overlayClassName={style.head_tooltip}
          >
            <Link
              onClick={store.toggleContactUsModal}
              style={{ height: TOP_HEADER_HEIGHT }}
            >
              <img
                src="https://qnm.hunliji.com/o_1dseje7f5ndb1pkv98cd7tjf0d.png"
                alt="联系我们"
                className={style['header-menu-icon']}
              />
              <span className={style['menu-name']}>联系我们</span>
              {visible && (
                <div
                  className={styles['csmInfo']}
                  style={{ left: smallWindow ? '-76px' : '-44px' }}
                >
                  <div className={styles['triangle']} />
                  <div>
                    亲爱的婚礼纪商家，小犀已将客户成功经理的微信二维码移至此处，如需可点击查看～
                  </div>
                </div>
              )}
            </Link>
          </Tooltip>
          <Head.ContactUsModal />
        </Menu.Item>
        {this?.props?.isShowPangu ? (
          <Menu.Item key="gotopangu">
            <Tooltip
              placement="bottom"
              title={smallWindow ? '官网首页' : ''}
              overlayClassName={style.head_tooltip}
            >
              <Link
                onClick={() => this.recordStoreJumpMode()}
                style={{
                  height: TOP_HEADER_HEIGHT,
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <img
                  style={{ width: '20px', height: '20px', marginRight: '6px' }}
                  src="//qnm.hunliji.com/o_1fe31th131mca1sbb1jbka7m10eqe.png"
                  alt="盘古跳转"
                  className={style['header-menu-icon']}
                />
                <span className={style['menu-name']}>进入新系统</span>
                <div
                  style={{
                    padding: '1px 4px',
                    background: '#ff4b4b',
                    border: '1px solid #ffffff',
                    borderRadius: '10px',
                    fontWeight: 500,
                    fontSize: '12px',
                    lineHeight: '18px',
                    color: '#ffffff',
                    marginLeft: '4px'
                  }}
                >
                  免费升级
                </div>
              </Link>
            </Tooltip>
          </Menu.Item>
        ) : null}
      </Menu>
    )
  }

  // 自定义menu-right
  RenderMenuRight = (style, store) => {
    const { city, name, merchant_support, mc_user } = getMerchantInfo()
    const { nick, phone } = merchant_support || {}
    const { avatar: actualAvatar } = mc_user || {}
    const { merchantList } = this.state
    const showSelectMerchant = isSanDaTeam() && merchantList.length
    return (
      <>
        <div className={showSelectMerchant ? '' : style['name-city']}>
          {showSelectMerchant ? (
            <Select
              className={styles['select-merchant']}
              dropdownClassName={styles['select-merchant-dropdown']}
              dropdownMatchSelectWidth
              style={{ minWidth: 150, maxWidth: 444, height: 32 }}
              value={merchantList[0].value}
            >
              {merchantList.map(({ label, value, mStoreId }) => (
                <Select.Option key={value} value={value}>
                  {value == merchantList[0].value ? (
                    label
                  ) : (
                    <LoginSub className={styles.login} storeId={mStoreId}>
                      {label}
                    </LoginSub>
                  )}
                </Select.Option>
              ))}
            </Select>
          ) : (
            <>
              <span>{name}</span>
              {city ? <span>&nbsp;|&nbsp;{city}</span> : null}
            </>
          )}
        </div>
        <span className={style['vertical-line']} />
        <Dropdown
          placement="bottomRight"
          overlayClassName={style['my-count-drop']}
          overlay={
            <Menu>
              <Menu.Item key="setting">
                <a
                  // eslint-disable-next-line
                  href={HLJ_MERCHANT_MY_COUNT + getJti()}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  我的账号
                </a>
              </Menu.Item>

              {/* <Menu.Item key="purchaseHistory">
              <Link to="/localMerchant/purchaseHistory">购买记录</Link>
            </Menu.Item>

            <Menu.Item key="myCoupon">
              <Link to="/localMerchant/myCoupon">我的卡券</Link>
            </Menu.Item> */}

              <Menu.Item key="logout">
                <a href="javascript:void(0)" onClick={logoutAction}>
                  退出登录
                </a>
              </Menu.Item>
            </Menu>
          }
        >
          <div className={style['my-count']}>
            <img
              src={isImageMogr2(actualAvatar || avatar, 32, 32)}
              alt="avatar"
            />
            <span style={{ maxWidth: 100 }}>
              {isSiDaTeam() || isSiDaMember() ? phone : nick}
            </span>
            <DownOutlined />
          </div>
        </Dropdown>
      </>
    )
  }

  render() {
    const { posterStore } = mainStore
    const { banner } = posterStore
    const headerParams = {
      logo: 'https://qnm.hunliji.com/o_1f1feoar418g2idd1k5i17sii1l9.png',
      ignoreFields: ['shoppingMall'],
      utils: { getJti },
      renderMenu: this.RenderMenu,
      renderMenuRight: this.RenderMenuRight
    }
    return (
      <div
        className={styles.headBox}
        style={{
          height: TOP_HEADER_HEIGHT,
          top: !this.props.banTopBanner
            ? banner.image_path
              ? TOP_BANNER_HEIGHT
              : 0
            : 0,
          minWidth: 1280
        }}
      >
        <Head {...headerParams} />
      </div>
    )
  }
}
